var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:_vm.$style['strapi-bg-image'],style:({ 'background-image': ("url(" + _vm.computedSrc + ")") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }